import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetdivisioncostspage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetDivisionCostsPage } = await import(
        /* webpackChunkName: "BudgetDivisionCostsPage" */ '../../../components/pages/private/BudgetDivisionCostsPage'
      )
      return {
        default: BudgetDivisionCostsPage,
      }
    })}
    exact
    key={paths.divisionCostsImport}
    path={paths.divisionCostsImport}
  />,
]
